/* Identidad compartida con CardVault — ADR 216 (CardVault).
 *
 * Hasta ahora el tema le decía a `cards.the-vault.mx` quién era el usuario
 * mandando su username en claro (`X-Vault-User`, leído de la cookie
 * `vault_user`). Cualquiera podía escribir esa cabecera con un `curl` y operar
 * como otra persona: escribirle la wishlist o, peor, hacer ofertas de compra a
 * su nombre.
 *
 * Ahora la identidad es un valor **firmado por el servidor** que vive en la
 * cookie `vault_auth`. El tema no la fabrica —no tiene la llave— y tampoco la
 * lee: la cookie es `HttpOnly` justamente para que ningún script de la página
 * (las apps de Shopify y los pixels corren aquí dentro) pueda llevársela. La
 * pide a CardVault, que la emite a nombre de quien trae la sesión, y el
 * navegador la manda solo en cada llamada: `the-vault.mx` y
 * `cards.the-vault.mx` son el mismo sitio y el fetch va con
 * `credentials: 'include'`.
 *
 * `vault_user` se queda donde estaba y para lo de siempre: **pintar** el nombre
 * en el header. Nunca decide permisos (ADR 038).
 *
 * Expone `window.VaultIdentidad`:
 *   .origen           → el origen de CardVault (prod o el proxy local)
 *   .usuarioVisible() → el username de `vault_user`, solo para pintar
 *   .asegurar()       → Promise<boolean>: se asegura de que la cookie exista
 */
(function () {
  var isLocal = window.location.port === '9292' || window.location.hostname === '127.0.0.1';
  var ORIGEN = isLocal ? 'http://cards.the-vault.mx:3000' : 'https://cards.the-vault.mx';

  function cookie(nombre) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + nombre + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function usuarioVisible() {
    return cookie('vault_user');
  }

  /* Una sola petición en vuelo: si tres corazones se pintan a la vez, no son
     tres viajes a CardVault. */
  var enVuelo = null;

  function pedirIdentidad() {
    if (enVuelo) return enVuelo;
    enVuelo = fetch(ORIGEN + '/api/auth/vault-identidad', {
      method: 'POST',
      credentials: 'include'
    })
      .then(function (res) { return res.ok; })
      .catch(function () { return false; })
      .then(function (ok) { enVuelo = null; return ok; });
    return enVuelo;
  }

  /* Se asegura de que el navegador tenga la cookie antes de la llamada real.
   *
   * No puede mirarla —es `HttpOnly`— así que decide por `vault_user`, la
   * visible: si hay sesión en CardVault, pide la identidad; CardVault contesta
   * 204 sin trabajo si la que el navegador ya manda sigue vigente, y 401 si la
   * sesión murió. `false` = esta persona no va a poder operar. */
  function asegurar() {
    if (!usuarioVisible()) return Promise.resolve(false);
    return pedirIdentidad();
  }

  window.VaultIdentidad = {
    origen: ORIGEN,
    usuarioVisible: usuarioVisible,
    asegurar: asegurar
  };
})();
